import { Button } from "theme-ui";
import ArrowButton from "../components/ArrowButton";

export default {
  ArrowButton,
  Button,
};
